import type { BrandConfig } from './types';

/**
 * Neutral brand for partner (white-label) hosts whose DB branding is missing or
 * incomplete. Every TagadaPay-specific value is stripped so nothing of ours can
 * leak onto a partner site: an unfilled field renders blank/neutral, never
 * "TagadaPay". Used as the merge base for `brandSource:'db'` hosts and the
 * reseller-slug context — the runtime DB overlay fills in whatever the partner
 * has set on top of this.
 *
 * `primaryColor` is the one field that must carry a value: theming and store
 * color pickers consume it, so it defaults to a brand-agnostic slate rather than
 * an empty string. Asset/identity fields stay blank on purpose (no invented
 * placeholder, no initials fallback).
 */
export const neutralBrand: BrandConfig = {
  appName: '',
  appDescription: '',
  companyName: '',

  appUrl: '',

  logo: '',
  favicon: '',

  primaryColor: '#64748b',

  features: {
    showRequestFeature: false,
    showSocialLinks: false,
    demoSeeding: false,
    showHelpVideos: false,
    showHub: false,
    showCalCom: false,
  },
};
